<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Cambio de Clave"></app-title-three>
  </div>

  <form [formGroup]="updatePasswordForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col size="12" class="ion-text-justify">
          <ion-item>
            <ion-label position="floating">Contraseña actual</ion-label>
            <ion-input
              mode="md"
              formControlName="password"
              maxlength="15"
              maxlength="15"
              id="password"
              type="password"
              [type]="typeInput[0]"
            >
            </ion-input>
            <ion-icon
              slot="end"
              [name]="eyeImage[0]"
              class="icon-password"
              (click)="changeImage(0)"
              mode="md"
            ></ion-icon>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="errorControl.password.errors != null && (errorControl.password.touched || errorControl.password.dirty)"
          >
            <ng-container
              *ngFor="let validation of validationMessages.password"
            >
              <div *ngIf="errorControl.password.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message }}</ion-text
                >
              </div>
            </ng-container>
          </div>

          <ion-item>
            <ion-label position="floating">Contraseña nueva</ion-label>
            <ion-input
              mode="md"
              formControlName="new_password"
              id="new_password"
              maxlength="15"
              [type]="typeInput[1]"
            >
            </ion-input>
            <ion-icon
              slot="end"
              [name]="eyeImage[1]"
              class="icon-password"
              (click)="changeImage(1)"
              mode="md"
            ></ion-icon>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="errorControl.new_password.errors != null && (errorControl.new_password.touched || errorControl.new_password.dirty)"
          >
            <ng-container
              *ngFor="let validation of validationMessages.new_password"
            >
              <div *ngIf="errorControl.new_password.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message }}</ion-text
                >
              </div>
            </ng-container>
          </div>

          <ion-item>
            <ion-label position="floating">Repetir contraseña</ion-label>
            <ion-input
              mode="md"
              formControlName="confirm_password"
              maxlength="15"
              id="confirm_password"
              [type]="typeInput[2]"
            >
            </ion-input>
            <ion-icon
              slot="end"
              [name]="eyeImage[2]"
              class="icon-password"
              (click)="changeImage(2)"
              mode="md"
            ></ion-icon>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="errorControl.confirm_password.errors != null && (errorControl.confirm_password.touched || errorControl.confirm_password.dirty)"
          >
            <ng-container
              *ngFor="let validation of validationMessages.confirm_password"
            >
              <div
                *ngIf="errorControl.confirm_password.hasError(validation.type)"
              >
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message }}</ion-text
                >
              </div>
            </ng-container>

            <div
              *ngIf="( errorControl.confirm_password.touched || errorControl.confirm_password.touched)  && errorControl.confirm_password.errors.confirmedValidator"
            >
              <ion-text color="primary" class="text-12"
                >Debe ser igual a la nueva clave.</ion-text
              >
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

  <ion-grid class="mt-20">
    <ion-row>
      <ion-col class="ion-text-center">
        <button
          shape="round"
          type="submit"
          [disabled]="updatePasswordForm.invalid"
          id="btn-create"
          class="btn-primary"
          (click)="changePassword()"
        >
          Actualizar
        </button>
      </ion-col>

      <ion-col size="12" class="center">
        <button
          (click)="closeModal()"
          id="close-modal"
          shape="round"
          class="btn-primary btn-close"
        >
          Cerrar
        </button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
